module.exports = __webpack_public_path__ + "media/src/images/partners/ebs-1681bbede555869f5dc517166926d39f.jpg";